import "bootstrap";
import Blazy from '../node_modules/blazy/blazy';
import "./js/searchbar";
// nothing yet

//Load images
var lazyLoadImages = function () {
  window.bLazy = new Blazy({
    breakpoints: [
      {
        width: 768,
        src: "data-src-small"
      },
      {
        width: 1024,
        src: "data-src-medium"
      }
    ],
    success: function (element) {
      $(element)
        .parent()
        .addClass("loaded");
    }
  });

  $(document).on("images:revalidate", function () {
    bLazy.revalidate();
  });

  $('.tab-content .tab-pane').on('shown.bs.tab', function () {
    if (window.bLazy) {
      setTimeout(function () {
        window.bLazy.revalidate();
      }, 50);
    }
  });
};

var initConceptsFiltering = function () {
  if (!$("#concepts-filter-form").length && !$("#concepts-results").length) {
    // No filtering at current page
    return;
  }
  
  // Search field
  $("#concepts-filter-form").on("submit", (e) => {
    e.preventDefault();
    let query = $("#concepts-filter-field").val();
    query = query ? query : "";
    let firstItem;
    
    $("#concepts-results > div.concept").each(function () {
      const concept = $(this).attr('id');
      const keywords = $(this).attr('keywords');
      if(insensContains(concept, query) || insensContains(keywords, query)){
         $(this).show()
        if(!firstItem){
          firstItem = $(this);
        }
         }
      else{
        $(this).hide()
      }
      
    });
    if(firstItem){
        firstItem.focus()
      }
    refreshButtons();
  })
  // Scroll
  $("#concepts-results").on("scroll", function (e) {
    refreshButtons()


  })

  // Button click 
$(".table-of-content").each(function () {
    $(this).children(".char-filter").on("click", (function () {

      $("#concepts-filter-field").val(""); // Clear search field
      $("#concepts-results > div.concept").show(); // Show all concepts
      
      let chars = $(this).attr("id");
      chars = chars.substring(0, chars.length - 3);
      let scrollTo;
      $("#concepts-results").children('div.concept:visible').each(function (i) {
        if ($(this).attr("id") === chars) {
          if (!scrollTo) {
            scrollTo = $(this)
          }
          return;
        }
      });
      if (scrollTo) {
        // scrollIntoView fails if outer scroll container is already in position
        // Scroll 1px up first to get past the bug
        $(window).scrollTop($(window).scrollTop()+1);
        scrollTo.get(0).scrollIntoView({ behavior: 'smooth' })
        scrollTo.focus();
      }
      refreshButtons();
    }))
  })
}

function refreshButtons() {
  let firstVisible;

  $("#concepts-results").children('div.concept').each(function (i) {
    if ($(this).isInViewport()) {
      if (!firstVisible) {
        firstVisible = $(this).attr("id")
      }
      return;
    }
  });
  resetActiveButtons();
  if(firstVisible){
    // If search field wipes all matches, firstVisible is not defined
    setActiveButton(firstVisible)
  }
}


const resetActiveButtons = function () {
  $(".table-of-content").each(function () {
    $(this).children().each(function () {
      $(this).removeClass("selected")
      $(this).removeAttr("aria-current")
    })
  })
}
const setActiveButton = function (chars) {
  if (!chars) {
    return;
  }

  $(".table-of-content").each(function () {
    $(this).children().each(function () {
      const filterBtnId = $(this).attr("id");
      const conceptId = filterBtnId.substring(0, $(this).attr("id").length - 3)
      if (conceptId === chars) {
        $(this).addClass("selected")
        $(this).attr("aria-current", true)
      } 
    })
  })
}
$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Calc container div distance from top
  var scrollTop = $(window).scrollTop(),
    elementOffset = $('#concepts-results').offset().top,
    distance = (elementOffset - scrollTop);

  return (elementBottom - distance) > viewportTop && elementTop < viewportBottom;
};


var insensContains = function (word, query) {
  return word.toLowerCase().includes(query.toLowerCase())
}

const updateNav = () => { 
  $('header a[href$="' + "/" + location.pathname.split("/")[1] + "/" + location.pathname.split("/")[2] + '"]').addClass('active');
  if(location.pathname === "/"){
    // no /fi/... prefix 
    $('a[href$="' + location.pathname + '"]').addClass('active');
  }
}
/**
 * initFilterSerch
 * A funtion for using a search field as a filter field
 * Takes CSS query string of input field as a parameter and overrides the element form submit
 * Merges ?s=searchword parameter to existing parameters instead of overwriting
 * 
 * TODOS 
 * - If the site will use this, changing the hard coded "s" key into field name makes this component more generic
 */
const initFilterSearch = (form) => {
  // Set search param to search field
  const searchParams = new URLSearchParams(window.location.search);
  $(form).children(".search-field").val(searchParams.get("s") || "")

  // Handle search with existing filtering
  $(form).on("submit", function(e) {

    let searchBox = $(this).children(".search-field")
    newFilterRoute("s", searchBox.val())
    e.preventDefault()
  })
}
/**
 * Inits all dropdown filter fields on the page
 */
function initFilterDropDowns(){
  $(".filter-select").each(function(){
    $(this).on("change", function(e){
      newFilterRoute($(this).attr("name"), $(this).val())
    })
  })
}


/**
 * Creates new query with GET parameters
 * Uses previous query without "s" key
 * @param {query key, e.g. "author"} key 
 * @param {query value, e.g. "Matti" } val 
 */
function newFilterRoute(key, val){
  const searchParams = new URLSearchParams(window.location.search);
  // Object to store filter parameters
  let newParams = []
  searchParams.forEach((loopVal, loopKey) => {
    if(loopKey !== "s" &&  loopKey !== "p" && loopKey !== key){
      newParams.push({key: loopKey, val: loopVal})
    }
  })
  if(val){
    newParams.push({key: key, val: val})
  }
  let queryPath = "?"
  if(newParams.length < 1){
    queryPath = ""
  }
  
  let loopFirst = true
  // Loop parameters from object to query string
  for(const param of newParams){
    if(!loopFirst){
      queryPath += "&"
    }
    queryPath += (param.key + "=" + param.val)
    loopFirst = false
  }
  // Set new url and open it
  let newUrl = window.location.origin + window.location.pathname + queryPath + '#article-widget';
  window.open(newUrl, "_self");
}

function initYoutubeVideo(){
  // player is a variable defined in templates/_youtubePlayer.twig script tag

  // Init video time links
  $(".video-time-link").each(function(){
    $(this).on("click", function(e){
      e.preventDefault();
      /**
       * Originally this was a link list within one video.
       * But now there is also a need to handle link to the
       * another video in video series list. Variable videoId
       * is only set in case of video series.
       */
      // Get currently playing video from player url (youtube.com/watch?v=<videoId>)
      $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(player.getVideoUrl());
        return (results !== null) ? results[1] || 0 : false;
      }
      let currentVideoId = $.urlParam('v');
      let time = $(this).attr("timeval");
      let videoId = $(this).attr("video-id-next");
      // If current video is different than link, change video
      if (videoId && currentVideoId !== videoId) {
        let startSeconds = time ? Number(time) : 0;
        player.loadVideoById({videoId, startSeconds});
        player.addEventListener('onStateChange', updateTime);
        // player.stopVideo();
        $(".video-card").each(function(){
          $(this).removeClass("selected")
        })
        $(this).closest(".video-card").addClass("selected");
      } else {
        player.seekTo(time, true);
      }

      $("#player").get(0).scrollIntoView({ behavior: 'smooth' })
      $("#player").focus()
    })
  })

  // Init video series links
  if($(".video-card")){
    $(".video-card").first().addClass("selected");
    $(".video-series-item").each(function(){
    $(this).on("click", function(e){
      e.preventDefault()
        let videoId = $(this).attr("video-id");
        let videoStarttime = $(this).attr("video-starttime");
        videoStarttime = videoStarttime ? Number(videoStarttime) : 0;
        player.loadVideoById(videoId, videoStarttime);
        /** 
         * Note that with stopVideo defined start time doesn't work.
         * Use pause if start time is defined.
         */
        if (videoStarttime > 0) {
          player.pauseVideo();
        } else {
          player.stopVideo();
        }
        player.addEventListener('onStateChange', updateTime);

        $("#player").get(0).scrollIntoView({ behavior: 'smooth' })
        $("#player").focus()

        $(".video-card").each(function(){
          $(this).removeClass("selected")
        })
        $(this).closest(".video-card").addClass("selected");


        return false;
    })
  })
 }
}

function updateTime(event) {
  /**
   * Update video length to the user.
   * New length is awailable only when the video
   * is started.
   */
  if (event.data == 1) {
    // new video is playing
    if($("#video-length-h")){
      // Set video length info on page
      let duration = player.getDuration();
      let hours = Math.floor(duration/3600);
      let minutes = Math.floor((duration - (hours*3600))/60);
      let seconds = Math.floor(duration - ((hours * 60 + minutes)*60));
      if (hours > 0) {
        $("#video-length-h").text(hours + ' h')
      }
      if (hours > 0 || (hours == 0 && minutes > 0)) {
        $("#video-length-min").text(minutes + ' min')
      }
      $("#video-length-sec").text(seconds + ' s')
    }
  }

}

/** Remove this feature. Temporarily? */
// function initRestaurointiPrint(){
//   $("#restaurointi-print").on("click", function() {
//     window.print();
//   })
// }

$(document).ready(function () {
  lazyLoadImages();
  initConceptsFiltering();
  updateNav();
  initFilterSearch("#periaate-search-form");
  initFilterDropDowns();
  initYoutubeVideo();
  // initRestaurointiPrint();
});